import type { Context } from "../context.js";

/**
 * Dwell de hover sobre elementos accionables (a/button), acumulado en ms en
 * ctx.hovers[selector]. Delegación con mouseover/mouseout (sin escuchar mousemove).
 */
function buildSelector(el: Element): string {
  if (el.id) return `#${el.id}`;
  const tag = el.tagName.toLowerCase();
  const cls = (el.getAttribute("class") || "").trim().split(/\s+/).filter(Boolean).slice(0, 2);
  return cls.length ? `${tag}.${cls.join(".")}` : tag;
}

export function startHover(ctx: Context) {
  if (ctx.state.device === "mobile") return; // no hay hover real en móvil
  const entered = new Map<Element, number>();

  document.addEventListener(
    "mouseover",
    (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const el = t?.closest("a, button, [role='button']");
      if (el && !entered.has(el)) entered.set(el, Date.now());
    },
    { passive: true }
  );

  document.addEventListener(
    "mouseout",
    (e) => {
      const t = e.target instanceof Element ? e.target : null;
      const el = t?.closest("a, button, [role='button']");
      if (!el) return;
      const start = entered.get(el);
      if (start == null) return;
      entered.delete(el);
      const sel = buildSelector(el);
      ctx.state.hovers[sel] = (ctx.state.hovers[sel] || 0) + (Date.now() - start);
      ctx.touch();
    },
    { passive: true }
  );
}
